// File: webelieve-frontend/src/features/matters/components/matter-detail-tabs/NotesTab.tsx
// Matter-scoped Notes tab — wraps NotesSplitView with matter_id scope

import React from 'react';
import { MatterDetailed } from '../../../../types/matters';
import NotesSplitView from '../../../notes/components/NotesSplitView';

interface NotesTabProps {
  matter: MatterDetailed;
  onUpdate?: (updatedMatter: MatterDetailed) => void;
}

const NotesTab: React.FC<NotesTabProps> = ({ matter }) => {
  return (
    <div className="h-full min-h-0 overflow-hidden">
      <NotesSplitView matterId={matter.id} clientId={matter.client_id} />
    </div>
  );
};

export default NotesTab;
